// extracted by mini-css-extract-plugin
module.exports = {"formButtonGroup":"_15ck3","centerAlign":"_3F29R"};